<template>
  <div>
    <b-modal
      id="modal-dar-baja-multa"
      v-model="$store.state.someVariables.showDarBajaMulta"
      title="Marcar valor como incobrable"
      ok-title="Confirmar baja"
      cancel-title="Cancelar"
      :ok-disabled="showLoadingTable"
      no-close-on-backdrop
      @ok="confirmarDarBaja"
    >
      <b-alert show variant="danger">
        Al marcar este valor como incobrable, no ingresará a las arcas de
        tesorería. ¿Por qué desea marcarlo como incobrable?
      </b-alert>
      <b-form-group label="Motivo de la baja" label-for="observacion-baja">
        <b-form-textarea
          id="observacion-baja"
          v-model="observacionBaja"
          placeholder="Ingrese el motivo"
          rows="3"
          max-rows="6"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import { ref } from '@vue/composition-api'
import { BFormTextarea, BFormGroup, BAlert } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import { URL, USER } from '../../utils/variables'

export default {
  components: {
    BFormTextarea,
    BFormGroup,
    BAlert,
  },
  props: {
    multaBajaSeleccionada: Object,
  },
  setup(props, { emit }) {
    const observacionBaja = ref('')
    const showLoadingTable = ref(false)
    const { postApi } = apiCall()

    async function confirmarDarBaja(bvModalEvt) {
      bvModalEvt.preventDefault()
      if (!observacionBaja.value.trim()) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Ingrese el motivo de la baja',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          { position: 'bottom-center' },
        )
        return
      }

      showLoadingTable.value = true
      const item = props.multaBajaSeleccionada
      const path = 'ApiMultas/daraBajaMultaIncobrable'
      const response = await postApi(URL, path, {
        id_multa: item.id_multa,
        motivo: observacionBaja.value.trim(),
        tiene_detalle: item.conDetalle,
        detalle: item.detalle,
        rol: USER().rol,
      })

      if (response !== null && response.flag === 'si') {
        // institucionSeleccionada.value.debe -= Number(item.v_total)
        // const found = listMultas.value.findIndex(
        //   element => element.id_multa === item.id_multa,
        // )
        // if (found !== -1) listMultas.value.splice(found, 1)
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Valor marcado como incobrable',
              icon: 'CheckIcon',
              variant: 'success',
              solid: true,
            },
          },
          { position: 'bottom-center' },
        )
        observacionBaja.value = ''
        store.commit('someVariables/UPDATE_SHOW_DAR_BAJA_MULTA', false)
        emit('actualizarTabla')
        // props.multaBajaSeleccionada.
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'No se pudo marcar el valor como incobrable',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              solid: true,
            },
          },
          { position: 'bottom-center' },
        )
      }
      showLoadingTable.value = false
    }

    return {
      observacionBaja,
      showLoadingTable,
      confirmarDarBaja,
    }
  },
}
</script>
